import type { GA4Event } from '@/ui/models/ga4';

const pushToDataLayer = (event: GA4Event): void => {
  try {
    if (typeof window !== 'undefined' && !window.dataLayer)
      window.dataLayer = [];

    if (typeof window !== 'undefined' && window.dataLayer)
      window.dataLayer.push(event);
  } catch (error) {
    console.error('[GA4] Error pushing event to dataLayer:', error);
  }
};

export default pushToDataLayer;
